import { useEffect, useRef } from 'react';

import { useIsNavigatingBack } from '../context/FlowContainerContext.tsx';

export function useScrollToError(error: string | undefined, extraDeps: unknown[] = []) {
  const rootRef = useRef<HTMLDivElement>(null);
  const isNavigatingBack = useIsNavigatingBack();

  useEffect(() => {
    if (isNavigatingBack || !error || !rootRef.current) {
      return;
    }

    rootRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const input = rootRef.current.querySelector('input, select, textarea');
    if (input) (input as HTMLElement).focus();
  }, [error, isNavigatingBack, ...extraDeps]);

  return rootRef;
}
